import styled from 'styled-components'
import { cssMediaQueryBreakpoints } from '../../../config/breakpoints'

export const StyledFeaturedArticleTitle = styled.h2`
    ${cssMediaQueryBreakpoints.medium} {
        font-size: 16px;
    }

    ${cssMediaQueryBreakpoints.small} {
        font-size: 14px;
    }

    font-size: 18px;
    font-weight: 500;
    color: ${p => p.theme.articleTextColor};
    opacity: 0.87;
    margin-bottom: 10px;
    margin-top: 4px;
`

export const StyledStandardArticleTitle = styled.h3`
    ${cssMediaQueryBreakpoints.small} {
        font-size: 12px;
        -webkit-line-clamp: 3;
    }

    font-size: 14px;
    font-weight: 500;
    color: ${p => p.theme.textColor};
    opacity: 0.87;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
`
